// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

document.addEventListener('click', function (event) {
  // If the clicked element doesn't have the right selector, bail
  if (!event.target.matches('.clickable-action')) return;

  // Don't follow the link
  event.preventDefault();

  // Perform the expected action
  const form = document.querySelector("form.clickable-action-form");
  form.action = event.target.dataset.url;
  form.submit();

}, false);

document.addEventListener('DOMContentLoaded', function () {
  const flashes = document.querySelectorAll("div.flash");

  flashes.forEach((flash) => {
    flash.classList.add("flash--visible");

    setTimeout(() => {
      flash.classList.remove("flash--visible");
    }, 3000);
  });
});
